module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kYqIg"))).then(() => parcelRequire('f4eak'));